// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_24a8_b","content":"_38cVBT","loading":"_2kTGtY","close-btn":"_1Y0C2p","buttons":"_23S_M_","container":"_3DghtM"};